const KNOWN_ENVS = new Set(['local', 'dev', 'prod'])

export function uiEnv() {
  const value = String(import.meta.env.VITE_APP_ENV || '').trim().toLowerCase()
  if (KNOWN_ENVS.has(value)) {
    return value
  }
  return 'unmatched'
}

export function uiBuild() {
  return import.meta.env.VITE_APP_BUILD || 'unknown'
}
